
export const CLIENT_RATING_BUTTONS = [
    {
      value: 'one-star',
      label: `One Star`,
      moreInfo: '',
      number: 1
    },
    {
      value: 'two-star',
      label: `Two Stars`,
      moreInfo: '',
      number: 2
    },
    {
      value: 'three-star',
      label: `Three Stars`,
      moreInfo: '',
      number: 3
    },
    {
      value: 'four-star',
      label: `Four Stars`,
      moreInfo: '',
      number: 4
    },
    {
      value: 'five-star',
      label: `Five Stars`,
      moreInfo: '',
      number: 5
    }
  ];

export const SUCCESS_BUTTONS = [
    {
      value: 'never',
      label: `Never`,
      moreInfo: '',
      number: 0
    },
    {
      value: 'rarely',
      label: `Rarely`,
      moreInfo: '(about 25% of the time)',
      number: 25
    },
    {
      value: 'sometimes',
      label: `Sometimes`,
      moreInfo: '(about 50% of the time)',
      number: 50
    },
    {
      value: 'often',
      label: `Often`,
      moreInfo: '(about 75% of the time)',
      number: 75
    },
    {
      value: 'always',
      label: `Always`,
      moreInfo: '',
      number: 100
    }
  ];

export function getClientRatingLabelForValue(value){
  let matchingLabel = "";
  CLIENT_RATING_BUTTONS.forEach(btn => {
    if(btn.value === value)
      matchingLabel = btn.label;
  })
  return matchingLabel;
}
export function getStarNumberForValue(value){
  let matchingNumber = null;
  CLIENT_RATING_BUTTONS.forEach(btn => {
    if(btn.value === value)
      matchingNumber = btn.number;
  })
  return matchingNumber;
}

export function getSuccessLabelForValue(value){
  let matchingLabel = "";
  SUCCESS_BUTTONS.forEach(btn => {
    if(btn.value === value)
      matchingLabel = btn.label;
  })
  return matchingLabel;
}
export function getSuccessNumberForValue(value){
  let matchingNumber = null;
  SUCCESS_BUTTONS.forEach(btn => {
    if(btn.value === value)
      matchingNumber = btn.number;
  })
  return matchingNumber;
}
